var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 10.8334C10.4615 10.8334 10.8346 10.4603 10.8346 10C10.8346 9.5398 10.4615 9.16671 10.0013 9.16671C9.54106 9.16671 9.16797 9.5398 9.16797 10C9.16797 10.4603 9.54106 10.8334 10.0013 10.8334Z",
    stroke: "#5A5555",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 5.00004C10.4615 5.00004 10.8346 4.62694 10.8346 4.16671C10.8346 3.70647 10.4615 3.33337 10.0013 3.33337C9.54106 3.33337 9.16797 3.70647 9.16797 4.16671C9.16797 4.62694 9.54106 5.00004 10.0013 5.00004Z",
    stroke: "#5A5555",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 16.6667C10.4615 16.6667 10.8346 16.2936 10.8346 15.8334C10.8346 15.3731 10.4615 15 10.0013 15C9.54106 15 9.16797 15.3731 9.16797 15.8334C9.16797 16.2936 9.54106 16.6667 10.0013 16.6667Z",
    stroke: "#5A5555",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.513f45d4d8d123f0aad20aad5a771d01.svg";
export { ForwardRef as ReactComponent };